import { CSSProperties } from "react";
import { theme } from "antd";
import Logo from "::assets/logo/taleemy-logo.png";
import styles from "./index.module.css";

const AppLoading = () => {
	const { token } = theme.useToken();
	const cssVars = {
		"--loading-bg": token.colorBgContainer,
		"--loading-track": token.colorFillSecondary,
		"--loading-bar": token.colorPrimary,
	} as CSSProperties;

	return (
		<div
			className={styles.screen}
			style={cssVars}
			role="status"
			aria-label="Loading"
		>
			<img src={Logo} alt="Ta3leemy Logo" className={styles.logo} />
			<span className={styles.loader} />
		</div>
	);
};

export default AppLoading;
